import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import {
  iconContainer,
  itemContainer,
  listItem,
  mainContent,
} from "./styles.module.scss"
import Icon from "../layout/icon"
import Separator from "../Separator/Separator"

const ListItemWithIcon = ({
  icon,
  children,
  showSeparator,
  iconSize,
  className,
}) => (
  <li className={classNames(listItem, className)}>
    {showSeparator && <Separator />}
    <div className={itemContainer}>
      <div className={iconContainer}>
        <Icon icon={icon} size={iconSize} />
      </div>
      <div className={mainContent}>{children}</div>
    </div>
  </li>
)

ListItemWithIcon.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.shape({
    iconName: PropTypes.string,
  }).isRequired,
  showSeparator: PropTypes.bool,
  className: PropTypes.string,
  iconSize: PropTypes.string,
}

ListItemWithIcon.defaultProps = {
  showSeparator: false,
  className: undefined,
  iconSize: undefined,
}

export default ListItemWithIcon
